<template>
  <div>
    <b-container class="" fluid>
      <b-row>
        <b-col class=""
          >
          <b-skeleton-wrapper class="text-center" :loading="miniresults.length <= 0">
            <template #loading>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="90%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="90%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="90%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
            </template>
            <h4>Score breakdown</h4>
            <div class="text-center list-heads pt-1">
              <p class="head-p" v-for="(score, index) in result[0].scores" :key="index">
                {{ score.name }}:
                <b>{{ score.score }}</b>
              </p>
            </div>

            <b-card class="mt-3">
              <div class="record-div">
                <p class="test-record p-2 mr-3">{{ result[0].category }}</p>
                <p class="test-record p-2 mr-3">
                  {{ result[0].institution_shortname }}
                </p>
                <p class="test-record p-2 mr-3">
                  {{ result[0].mode }} Mode
                  {{
                    result[0].mode == "Topic"
                      ? "(" + result[0].mode_config.subject + ")"
                      : ""
                  }}
                </p>
                <p class="test-record p-2 mr-3">{{ result[0].course }}</p>
                <p class="test-record p-2 mr-3">
                  <b>taken on {{ result[0].date }}</b>
                </p>
              </div>

              <b-skeleton-wrapper class="text-center" :loading="miniresults.length <= 0">
                <template #loading>
                  <b-skeleton width="100%"></b-skeleton>
                  <b-skeleton width="80%"></b-skeleton>
                  <b-skeleton width="90%"></b-skeleton>
                  <b-skeleton width="100%" class="mt-3"></b-skeleton>
                  <b-skeleton width="80%"></b-skeleton>
                  <b-skeleton width="90%"></b-skeleton>
                  <b-skeleton width="100%" class="mt-3"></b-skeleton>
                  <b-skeleton width="80%"></b-skeleton>
                  <b-skeleton width="100%"></b-skeleton>
                  <b-skeleton width="100%" class="mt-3"></b-skeleton>
                  <b-skeleton width="80%"></b-skeleton>
                  <b-skeleton width="100%"></b-skeleton>
                  <b-skeleton width="100%" class="mt-3"></b-skeleton>
                  <b-skeleton width="80%"></b-skeleton>
                  <b-skeleton width="90%"></b-skeleton>
                  <b-skeleton width="100%" class="mt-3"></b-skeleton>
                  <b-skeleton width="80%"></b-skeleton>
                  <b-skeleton width="100%"></b-skeleton>
                </template>
              </b-skeleton-wrapper>
              <div class="solution-header-wrapper mb-0">
                <p class="solution-header p-2 pt-lg-3">Solutions & Questions review</p>
                <p class="solution-header-2">
                  <b-overlay
                    :show="trialsLeft"
                    opacity="0.7"
                    spinner-variant="dark"
                    spinner-small
                    rounded
                    class="overlay-width"
                  >
                    <template v-slot:overlay>
                      <b-link :to="{ name: 'upgrade' }">
                        <div class="text-center mt-4 w-100">
                          <p>
                            <b-icon-lock-fill
                              variant="warning"
                              font-scale="2"
                            ></b-icon-lock-fill>
                            Upgrade to Unlock
                          </p>
                        </div>
                      </b-link>
                    </template>
                    <b-button
                      hidden
                      class="hidden mt-lg-3 action-button"
                      variant="success"
                      @click="downloadAll = true"
                      ><b-icon-file-earmark-arrow-down></b-icon-file-earmark-arrow-down>
                      Download Full Solutions (pdf)
                    </b-button>
                  </b-overlay>
                </p>
              </div>

              <b-overlay
                :show="this.trialsLeft"
                opacity="0.7"
                spinner-variant="dark"
                spinner-small
                rounded
              >
                <template v-slot:overlay>
                  <b-link :to="{ name: 'upgrade' }">
                    <div class="text-center mt-4 w-100">
                      <p>
                        <b-icon-lock-fill
                          variant="warning"
                          font-scale="2"
                        ></b-icon-lock-fill>
                        Upgrade to Unlock
                      </p>
                    </div>
                  </b-link>
                </template>
                <s-qwrapper
                  v-for="(questions, index) in result[0].questions"
                  :key="index"
                  :questions="questions"
                  :attempted="result[0].questions_attempted"
                  :tstructure="result[0].structure"
                  :download-all="downloadAll"
                ></s-qwrapper>
                <b-skeleton-wrapper
                  class="text-center"
                  :loading="miniresults.length <= 0"
                >
                  <template #loading>
                    <b-skeleton width="100%"></b-skeleton>
                    <b-skeleton width="80%"></b-skeleton>
                    <b-skeleton width="90%"></b-skeleton>
                    <b-skeleton width="100%" class="mt-3"></b-skeleton>
                    <b-skeleton width="80%"></b-skeleton>
                    <b-skeleton width="90%"></b-skeleton>
                    <b-skeleton width="100%" class="mt-3"></b-skeleton>
                    <b-skeleton width="80%"></b-skeleton>
                    <b-skeleton width="100%"></b-skeleton>
                    <b-skeleton width="100%" class="mt-3"></b-skeleton>
                    <b-skeleton width="80%"></b-skeleton>
                    <b-skeleton width="100%"></b-skeleton>
                    <b-skeleton width="100%" class="mt-3"></b-skeleton>
                  </template>
                </b-skeleton-wrapper>
              </b-overlay>
            </b-card>
          </b-skeleton-wrapper>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import sQwrapper from "@/components/sQwrapper";
import { mapState, mapActions } from "vuex";
//import ResultPerf from '@/components/ResultPerf'

export default {
  components: {
    sQwrapper,
  },
  props: ["trackid", "fromp"],
  data() {
    return {
      //quotes: this.getQuote(),
      curD: new Date(),
      result: [{ scores: 0 }],
      test: "category",
      userresult: [{ scores: 0 }],
      overallscore: 0,
      downloadAll: false,
    };
  },
  created() {},
  async mounted() {
    await this.$store.dispatch("dashboard/getminiresults");
    await this.$store.dispatch("dashboard/getmaxiresults");
    this.getSettings();
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == "submitted") next({ name: "dashhome" });
    else next();
  },
  methods: {
    getResults() {},
    graphdata() {
      this.result[0].scores.forEach((x) => {
        x.name;
      });
    },
    getSettings() {
      let trid = this.$route.params.trackid;

      this.userresult = this.miniresults;
      let curres = this.userresult.filter((x) => x.track_id == trid);
      this.result = curres;

    
      this.retrieveInstitutions().then(() => {
        let insti = this.result[0].institution;
        //console.log(this.allinsti)

        let category = this.result.category;
        let structure = this.result.structure;

        if (structure == "Section") {
          let level = this.result.level;
          let course = this.result.course;

          let levell = this.allinsti
            .filter((x) => x.name == insti && x.category == category)
            .map((x) => x.levels_config);

          let lev = JSON.parse(levell);
          let rlevel = lev.filter((x) => x.name == level).map((y) => y.config);

          let rlev = rlevel[0];
          // vconsole.log(rlev);
          let icourses = rlev.filter((x) => x.name == "courses").map((x) => x.values);
          let itm = rlev.filter((x) => x.name == "totalmarks").map((x) => x.values);

          let rcindex = icourses[0].indexOf(course);
          let rtm = itm[0][rcindex];

          this.overallscore = Number(rtm);

          //console.log(rtm);
          //console.log(rcindex);
        } else {
          let overall = this.allinsti
            .filter((x) => x.name == insti)
            .map((x) => x.total_marks);
          //console.log(overall[0])
          this.overallscore = overall[0];
        }
      });
    },

    ...mapActions("exam", ["retrieveInstitutions"]),
  },
  watch: {
    maxiresults() {
      if (this.maxiresults.length > 0) {
        this.userresult = this.maxiresults;
        this.getSettings();
      }
    },
    miniresults() {
      if (this.miniresults.length > 0 && this.maxiresults.length <= 0) {
        this.userresult = this.miniresults;
        this.getSettings();
      }
    },
  },
  computed: {
    ...mapState({
      plan: (state) => state.loginmaster.details.plan,
      miniresults: (state) => state.dashboard.lresults,
      details: (state) => state.loginmaster.details,
      maxiresults: (state) => state.dashboard.mlresults,
      trial: (state) => state.loginmaster.trial,
      allinsti: (state) => state.exam.allinstitutions,
      freePeriod: (state) => state.loginmaster.freePeriod,
      maxiresultfetched: (state) => state.dashboard.maxiresultfetched,
    }),
    getQuote() {
      let randn = Math.random();

      if (this.result[0].total_score > 0.69 * this.overallscore) {
        let index = this.msgarr69.length * randn;

        let quote = this.msgarr69[index];

        return quote;
      } else if (this.result[0].total_score < 0.19 * this.overallscore) {
        let index = this.msgarr19.length * randn;

        let quote = this.msgarr19[index];

        return quote;
      } else {
        return "You Tried";
      }
    },
    chgcurr() {
      let trid = this.$route.params.trackid;
      let curres = this.userresult.find((x) => x.track_id == trid);

      if (curres) {
        return curres;
      } else {
        return {};
      }
    },
    retrieving() {
      let trid = this.$route.params.trackid;

      let curres = this.userresult.filter((x) => x.track_id == trid);

      if (curres.length <= 0) {
        return true;
      } else {
        return false;
      }
    },
    trialsLeft() {
      if (this.freePeriod) {
        return false;
      } else if (this.chgcurr.test_source == "thirdparty") {
        return false;
      } else if (this.details.clearance_organization == "Quicktest") {
        return false;
      } else if (this.trial > 0) {
        return false;
      } else if (this.plan == "Premium") {
        return false;
      } else if (this.trial <= 0 && this.plan != "Premium") {
        return true;
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped>
.fhe {
  background-color: #00377b;
  color: white;
  border-radius: 20px 20px 0px 0px;
  font-weight: bold;
}

.detailsflex {
  display: flex;
}

.detailslabel {
  width: 40%;
  font-size: 1.1rem;
}

.detailsvalue {
  width: 60%;
  font-size: 1.2rem;
  font-weight: bolder;
}

.sqheader {
  font-size: 1.2rem;
  background-color: rgba(255, 255, 255, 0.938);
  border-radius: 10px 10px;
  display: flex;
  font-weight: bold;
}

.heasub {
  width: 70%;
}

.sqicon {
  width: 30%;
  text-align: right;
  cursor: pointer;
}

.form-rad {
}

.dispf {
  display: flex;
  margin-top: -10px;
  cursor: pointer;
}

.spinver {
  width: 7rem;
  height: 7rem;
}
.list-heads {
  background-color: #00984a;
  color: white;
  border-radius: 5px 5px;
  font-weight: bold;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}
.head-p {
  width: 15%;
  padding: 2px;
  /* padding-top: ; */
}
.solution-header-wrapper {
  display: flex;
  flex-flow: row wrap;
}
.solution-header {
  width: 50%;
  font-weight: bolder;
  font-size: 1.2rem;
}
.solution-header-2 {
  width: 50%;
  text-align: right;
}
.record-div {
  display: flex;
  justify-content: flex-start;
  flex-flow: row wrap;
}
.test-record {
  font-size: 1rem;
}
.action-button {
  width: 300px;
}

@media screen and (max-width: 999px) {
  .head-p {
    font-size: 0.6rem;
  }
  .test-record {
    font-size: 0.7rem;
  }
  .solution-header {
    width: 100%;
  }
  .solution-header-2 {
    width: 100%;
    text-align: center;
  }
  .action-button {
    width: 250px;
    font-size: 0.8rem;
  }
}
</style>
